// src/store/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  avatar?: string;
  provider: "email" | "google" | "apple";
}

export interface TenantStatus {
  is_inactive: boolean;
  inactivated_at: string;
  days_inactive: number;
  history_access_remaining_days: number;
  scan_allowed: boolean;
  history_allowed: boolean;
  message: string;
}

interface UserState {
  user: User | null;
  token: string | null;
  refreshToken: string | null;
  apiKey: string | null;
  roles: string[];
  modules: string[];
  permissions: string[];
  tenantId: string | null;
  tenantStatus: TenantStatus | null;
  isAuthenticated: boolean;
  loginAt: number | null;
  isDemo: boolean;
}

const initialState: UserState = {
  user: null,
  token: null,
  refreshToken: null,
  apiKey: null,
  roles: [],
  modules: [],
  permissions: [],
  tenantId: null,
  tenantStatus: null,
  isAuthenticated: false,
  loginAt: null,
  isDemo: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action: PayloadAction<string>) => {
      state.refreshToken = action.payload;
    },
    setApiKey: (state, action: PayloadAction<string>) => {
      state.apiKey = action.payload;
    },
    setRoles: (state, action: PayloadAction<string[]>) => {
      state.roles = action.payload;
    },
    setModules: (state, action: PayloadAction<string[]>) => {
      state.modules = action.payload;
    },
    setLoginAt: (state, action: PayloadAction<number>) => {
  state.loginAt = action.payload;
},
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
    },
    setTenantId: (state, action: PayloadAction<string>) => {
      state.tenantId = action.payload;
    },
    setTenantStatus: (state, action: PayloadAction<TenantStatus | null>) => {
      state.tenantStatus = action.payload;
    },
    setIsDemo: (state, action: PayloadAction<boolean>) => {
      state.isDemo = action.payload;
    },
    resetUserState: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.apiKey = null;
      state.roles = [];
      state.modules = [];
      state.permissions = [];
      state.tenantId = null;
      state.tenantStatus = null;
      state.isAuthenticated = false;
      state.loginAt = null;
      state.isDemo = false;
    },
  },
});

export const {
  setUser,
  setLoginAt,
  setToken,
  setRefreshToken,
  setApiKey,
  setRoles,
  setModules,
  setPermissions,
  setTenantId,
  setTenantStatus,
  setIsDemo,
  resetUserState,
} = userSlice.actions;

export default userSlice.reducer;